var _defs, _path, _path2, _path3, _path4, _rect, _polyline, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJanela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.66,40.31c-4.3,0-4.8,.5-4.8,4.8,0-4.3-.5-4.8-4.8-4.8,4.3,0,4.8-.5,4.8-4.8,0,4.3,.5,4.8,4.8,4.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.91,59.09c-3.23,0-3.61,.38-3.61,3.61,0-3.23-.38-3.61-3.61-3.61,3.23,0,3.61-.38,3.61-3.61,0,3.23,.38,3.61,3.61,3.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.85,65.87c-2.04,0-2.28,.24-2.28,2.28,0-2.04-.24-2.28-2.28-2.28,2.04,0,2.28-.24,2.28-2.28,0,2.04,.24,2.28,2.28,2.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.16,17.68h42.51c1.57,0,2.85,1.28,2.85,2.85h0c0,1.57-1.28,2.85-2.85,2.85H29.32c-1.57,0-2.85-1.28-2.85-2.85h0c0-1.57,1.28-2.85,2.85-2.85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 5.7,
    rx: 2.17,
    ry: 2.17,
    width: 49.05,
    x: 26.47,
    y: 77.81
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "72.87 62.78 72.87 77.81 29.11 77.81 29.11 23.38 72.87 23.38 72.87 61.72"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 18.38,
    width: 15.54,
    x: 33.53,
    y: 30.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 18.38,
    width: 15.54,
    x: 53.09,
    y: 30.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 18.38,
    width: 15.54,
    x: 33.36,
    y: 52.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 18.38,
    width: 15.54,
    x: 52.92,
    y: 52.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.75,
    x2: 36.63,
    y1: 33.36,
    y2: 36.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.13,
    x2: 43.02,
    y1: 42.42,
    y2: 45.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.36,
    x2: 36.82,
    y1: 34.13,
    y2: 43.91
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.05,
    x2: 55.94,
    y1: 55.75,
    y2: 59.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.44,
    x2: 62.32,
    y1: 64.81,
    y2: 68.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.66,
    x2: 56.13,
    y1: 56.52,
    y2: 66.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJanela);
export default __webpack_public_path__ + "static/media/janela.d1a1d5a4884c9c8bcb5a4d3d435e1349.svg";
export { ForwardRef as ReactComponent };